'use strict';

import { view } from '@/functions';

export default [
    {
        path: '/ai-models',
        name: 'ai-models',
        meta: {
            title: 'AI models',
            scopes: ['read_ai_conversations'],
        },
        component: () => view('ai-models/index'),
    },
];
